module.exports = __webpack_public_path__ + "static/img/cy.6d82b6c7.svg";